import React from 'react';
import {
  ApartmentOutlined,
  FileOutlined,
  ImportOutlined,
  MedicineBoxOutlined,
} from '@ant-design/icons';

import { AdditionalContext } from '@totem/components/ui_components/menus/mainMenu/additionalContext';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import {
  isMemberOfAny,
  securityGroupCheckConstraintAny,
} from '@totem/components/userContext/security/userUtilities';
import IBDIcon from '@totem/styles/Icon';
import { UserProfile } from '@totem/types/user';
import { isNotNull } from '@totem/utilities/common';

export const getSubMenuReports = (
  userProfile: UserProfile,
  additionalContext: AdditionalContext,
) => {
  const items: IBMenuItem[] = [
    {
      key: 'crossorgdevices',
      title: 'Devices',
      label: 'Devices',
      description: 'Devices Across ALL Organizations',
      route: '/dashboard/adminDevices',
      icon: <IBDIcon name="Device" />,
      hasPermissions: () => {
        return permissions.internalIBOrg.hasPermissions(userProfile);
      },
    },
    {
      key: 'crossorggateways',
      title: 'Gateways',
      label: 'Gateways',
      description: 'Gateways Across ALL Organizations',
      route: '/dashboard/adminGateways',
      icon: <IBDIcon name="Device" />,
      hasPermissions: () => {
        return permissions.internalIBOrg.hasPermissions(userProfile);
      },
    },
    {
      key: 'netsuite_pending',
      title: 'NetSuite Pending',
      label: 'NetSuite Pending',
      description: 'Sales Orders Pending Import',
      route: '/dashboard/pendingImports',
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return permissions.internalIBOrgContractManagement.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'os_patching',
      title: 'OS Patching',
      label: 'OS Patching',
      description: 'OS Patching Report',
      route: '/dashboard/osPatching',
      icon: <MedicineBoxOutlined />,
      hasPermissions: () => {
        return permissions.rmm.hasPermissions(userProfile);
      },
    },
    {
      key: 'network_concerns',
      title: 'Network Concerns',
      label: 'Network Concerns',
      description: 'Network Concerns',
      route: '/dashboard/networkConcerns',
      icon: <ApartmentOutlined />,
      hasPermissions: () => {
        return permissions.internalRMM.hasPermissions(userProfile);
      },
    },
    {
      key: 'software_vulnerabilities',
      title: 'Software Vulnerabilities',
      label: 'Software Vulnerabilities',
      description: 'Software Vulnerabilities',
      route: '/dashboard/software/vulnerabilityReport',
      icon: <ApartmentOutlined />,
      hasPermissions: () => {
        return permissions.rmm.hasPermissions(userProfile);
      },
    },
  ];

  if (
    isNotNull(additionalContext) &&
    isNotNull(additionalContext.reports) &&
    additionalContext.reports.length > 0
  ) {
    for (let idx = 0; idx < additionalContext.reports.length; idx++) {
      items.push({
        key: additionalContext.reports[idx].id,
        title: additionalContext.reports[idx].name,
        label: additionalContext.reports[idx].name,
        description: additionalContext.reports[idx].name,
        route: `/dashboard/${additionalContext.reports[idx].link}`,
        icon: <FileOutlined />,
        hasPermissions: () => {
          return (
            userProfile.organization.role >
              additionalContext.reports[idx].minimum_role &&
            isMemberOfAny(
              userProfile,
              additionalContext.reports[idx].security_groups,
              securityGroupCheckConstraintAny,
            )
          );
        },
      });
    }
  }

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
